









export default {
    name: 'NotFound.vue'
};
